/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

import Swiper, { Thumbs, Navigation, Pagination, EffectFade } from 'swiper';
import 'swiper/swiper-bundle.css';

window.addEventListener('load', () => {
  Swiper.use([Thumbs, Navigation, Pagination, EffectFade]);

  const productSwiperThumbs = new Swiper('.product-swiper .thumbs', {
    spaceBetween: 8,
    slidesPerView: 'auto',
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true
  });

  const productSwiper = new Swiper('.product-swiper .swiper', {
    spaceBetween: 10,
    loop: true,
    thumbs: {
      swiper: productSwiperThumbs,
    },
  })


	// Complex carousel
	const swiperSlide =  new Swiper('.swiper--large .swiper--slide .swiper', {
    slidesPerView: 1,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
	});

	new Swiper('.swiper--large .swiper--fade .swiper', {
		autoHeight: true,
		pagination: {
			el: '.swiper--fade .pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.swiper--fade .next',
			prevEl: '.swiper--fade .prev',
		},
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		thumbs: {
      swiper: swiperSlide,
    },
		breakpoints: {
			768: {
					autoHeight: false
			}
		}
	});
});
